<template>
  <div>优惠卷管理</div>
</template>

<script>
export default {

}
</script>

<style>

</style>